import React from 'react';
import { Link } from 'react-router-dom';

const LegalLayout = ({ title, effectiveDate, lastUpdated, children }) => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
      <header className="px-4 md:px-6 lg:px-8 py-4 flex items-center justify-between max-w-3xl mx-auto" style={{ borderBottom: '1px solid var(--color-border)' }}>
        <Link to="/" className="flex items-center gap-2" aria-label="Got Next">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary)' }}>
            <span style={{ fontSize: '18px', lineHeight: 1 }}>🏀</span>
          </div>
          <span className="font-heading font-bold text-lg" style={{ color: 'var(--color-foreground)' }}>
            Got <span style={{ color: 'var(--color-primary)' }}>Next</span>
          </span>
        </Link>
        <Link to="/" className="font-caption text-sm font-medium transition-colors hover:opacity-80" style={{ color: 'var(--color-muted-foreground)' }}>
          Home
        </Link>
      </header>

      <main className="px-4 md:px-6 lg:px-8 py-10 md:py-14 max-w-3xl mx-auto">
        <h1 className="font-heading font-bold text-3xl md:text-4xl mb-3" style={{ color: 'var(--color-foreground)' }}>
          {title}
        </h1>
        <p className="font-caption text-xs mb-8" style={{ color: 'var(--color-muted-foreground)' }}>
          Effective {effectiveDate} · Last updated {lastUpdated}
        </p>
        <div className="legal-content space-y-5">
          {children}
        </div>
      </main>

      <footer className="px-4 md:px-6 lg:px-8 py-6 max-w-3xl mx-auto" style={{ borderTop: '1px solid var(--color-border)' }}>
        <div className="flex items-center justify-center gap-4">
          <Link to="/privacy" className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>Privacy</Link>
          <Link to="/terms" className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>Terms</Link>
        </div>
      </footer>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    {heading && (
      <h2 className="font-heading font-bold text-xl mt-8 mb-3" style={{ color: 'var(--color-foreground)' }}>
        {heading}
      </h2>
    )}
    <div className="space-y-3 font-body text-sm md:text-base leading-relaxed" style={{ color: 'var(--color-muted-foreground)' }}>
      {children}
    </div>
  </section>
);

export const LegalSubheading = ({ children }) => (
  <h3 className="font-heading font-semibold text-base mt-4 mb-1" style={{ color: 'var(--color-foreground)' }}>
    {children}
  </h3>
);

export const LegalList = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1">
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);

export default LegalLayout;
